import Immutable from 'immutable';
import ActionTypes from '../ActionTypes';
import createReducer from '../../util/createReducer';

const initialState = Immutable.fromJS({
  selectedUser: 'all',
  filter: 'all',
  activeTrip: null,
});

export default createReducer(initialState, {
  [ActionTypes.Trips.setValue](state, { field, value }) {
    return state.set(field, value);
  },
});



// WEBPACK FOOTER //
// /src/store/reducers/Trips.js